var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFiSrHome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_33_866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 11.2438C7.75737 11.2438 6.75 12.2512 6.75 13.4938V17.9938H11.25V13.4938C11.25 12.2512 10.2426 11.2438 9 11.2438Z",
    fill: "#22CAAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 13.4942V17.9942H15.75C16.9926 17.9942 18 16.9868 18 15.7442V8.90342C18.0002 8.51379 17.8488 8.13937 17.5777 7.85942L11.2043 0.969152C10.0797 -0.247606 8.18167 -0.322313 6.96491 0.802265C6.90711 0.855702 6.85143 0.911355 6.79802 0.969152L0.435762 7.85717C0.156551 8.13828 -0.000105416 8.51846 5.32206e-08 8.91467V15.7442C5.32206e-08 16.9868 1.00737 17.9942 2.25 17.9942H5.24999V13.4942C5.26402 11.4491 6.9152 9.77899 8.9088 9.7309C10.9691 9.68119 12.7343 11.3797 12.75 13.4942Z",
    fill: "#22CAAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 11.2438C7.75737 11.2438 6.75 12.2512 6.75 13.4938V17.9938H11.25V13.4938C11.25 12.2512 10.2426 11.2438 9 11.2438Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_33_866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiSrHome);
export default __webpack_public_path__ + "static/media/fi-sr-home.650bf0638d98c8a4079a7b571504ee24.svg";
export { ForwardRef as ReactComponent };